import { pxToRem } from '../../helpers'
import { StyleFn } from '..'

import LogoAms from 'resources/images/logoAmasis_alpha.png'

// TODO prominent variant with collapsed sub classes
// FIXME should we default to fixed position or implement automatic fallback / polyfill ?
// FIXME should we define classes for each positioning like MUI ?
// @see https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/AppBar/AppBar.js

export const logoWidth = 86
export const logoHeight = 40
export const logoDarkWidth = 86
export const logoDarkHeight = 16

export const Header: StyleFn = ({ asset, color, elevation, font, size }) => ({
  root: {
    backgroundColor: color.getModalValues(color.background.primary),
    color: color.getModalValues(color.text.primary),
    fontSize: font.size.small,
    fontWeight: font.weight.medium,
    lineHeight: font.lineheight.small,
    display: 'flex',
    width: '100%',
    padding: 0,
    boxSizing: 'border-box',
    overflowX: 'hidden',
    overflowY: 'hidden',
    alignItems: 'center',
    minHeight: size.spacing[56],
    paddingRight: size.spacing[16],
    zIndex: elevation.zindex.header,
    flexShrink: 0,
    boxShadow: elevation.level1,
    // ⚠️ sticky is not supported by IE 11
    position: 'sticky',
    top: 0,
    left: 'auto',
    right: 0,
    '& > :not(:first-child)': {
      marginRight: size.spacing[8],
    },
  },
  home: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 'auto',
    cursor: 'pointer',
  },
  logo: {
    margin: size.spacing[16],
    // backgroundImage: `url('data:image/svg+xml;base64,${color.type === 'dark' ? airbusLogo : airbusDarkLogo}')`,
    backgroundImage: `url(${LogoAms})`,
    backgroundRepeat: 'no-repeat',
    width: pxToRem(logoWidth),
    height: pxToRem(logoHeight),
    backgroundSize: `${pxToRem(logoWidth)} ${pxToRem(logoHeight)}`,
    flexShrink: 0,
  },
  appname: {
    // increase specificity and defeat global styles
    '&$appname': {
      all: 'unset',
      flex: 1,
      paddingLeft: size.spacing[16],
      paddingRight: size.spacing[16],
      fontSize: font.size.medium,
      fontWeight: font.weight.regular,
      lineHeight: font.lineheight.medium,
      whiteSpace: 'nowrap',
      borderLeft: `1px solid ${color.type === 'dark' ? color.palette.white : color.palette.coolgrey[90]}`,
      color: 'inherit',
      textAlign: 'left',
    },
  },
  _nopadding: {
    paddingRight: 0,
  },
  _transparent: {
    backgroundColor: 'transparent !important',
    boxShadow: 'inherit',
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      left: size.spacing[16],
      right: size.spacing[16],
      bottom: 0,
      borderBottom: `solid 1px ${color.palette.white}`,
    },
  },
})
